/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
// import { dataArray } from './data';
import { Card, Col, Row } from 'react-bootstrap';
import useHttpApiCall from '../../services/useHttpApiCall';
import moment from 'moment';
import { GoAlert } from 'react-icons/go';
import { useParams, useSearchParams } from 'react-router-dom';

export const SlideShow = ({ click, isFullscreen, handleExitFullscreen, id }) => {
  const [tasks, setTasks] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [canPlaySound, setCanPlaySound] = useState(false);
  const [slideshowPayload, setSlideshowPayload] = useState(undefined);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isElementVisible, setIsElementVisible] = useState(true);
  const [lastTimeStamp, setLastTimeStamp] = useState(null);
  const [subSlideIndex, setSubSlideIndex] = useState(0);
  const [error, setError] = useState(null);

  const TIME_TO_TRIGGER = 30 * 1000;
  const EXTRATIME_TO_TRIGGER = 120000;
  let addPointApiTimer, loadingTimer;
  const is_shopfloor_viewer = localStorage.getItem('is_shopfloor_viewer') == 'true' ? true : false;
  const [data,loading, apiError] = useHttpApiCall(slideshowPayload);
  const { id: idFromParams } = useParams();
  const slideShowId = idFromParams || id;
  const [searchParams] = useSearchParams();
  const isFullWindowed = (searchParams.get('full_windowed') || '') === '1' && !isFullscreen;

  const nextSlide = () => {
    if (!tasks?.tagged_slides?.length) return;

    setSubSlideIndex((prevSubIndex) => {
      const currentSlideData = tasks.tagged_slides[currentSlideIndex];
      const equipmentCount = currentSlideData?.tagged_equipment?.length || 0;
      
      // Only chunk if we have more than 12 cards
      let equipmentChunks = [];
      if (equipmentCount > 12) {
        equipmentChunks = chunkArray(currentSlideData?.tagged_equipment || [], 12);
      } else if (equipmentCount > 0) {
        // For slides with 12 or fewer cards, just use the entire array as one chunk
        equipmentChunks = [currentSlideData?.tagged_equipment || []];
      }

      // If no equipment or chunks, move to next main slide
      if (equipmentChunks.length === 0) {
        setCurrentSlideIndex((prev) => (prev + 1) % tasks.tagged_slides.length);
        return 0;
      }

      // If we can move to next sub-slide
      if (prevSubIndex + 1 < equipmentChunks.length) {
        return prevSubIndex + 1;
      } else {
        // Move to next main slide
        setCurrentSlideIndex((prev) => (prev + 1) % tasks.tagged_slides.length);
        return 0;
      }
    });
  };

  useEffect(() => {
    if (!slideShowId) {
      setError('Invalid slideshow. Please check the link.');
    }
  }, [slideShowId]);

  useEffect(() => {
    // Reset subSlideIndex when switching slides
    const currentSlideData = tasks.tagged_slides?.[currentSlideIndex];
    const equipmentCount = currentSlideData?.tagged_equipment?.length || 0;
    
    // Only reset if current slide has 12 or fewer cards
    if (equipmentCount <= 12) {
      setSubSlideIndex(0);
    }
  }, [currentSlideIndex, tasks]);

  useEffect(() => {
    currentSlideIndex > tasks?.tagged_slides?.length - 1 && setCurrentSlideIndex(0);
  }, [currentSlideIndex]);

  // Automatically move to the next slide every second
  useEffect(() => {
    if (error || !tasks?.tagged_slides?.length) return;
    const interval = setInterval(nextSlide, 6000);
    return () => clearInterval(interval);
  }, [tasks, error, currentSlideIndex, subSlideIndex]);

  useEffect(() => {
    if (lastTimeStamp) {
      let lastTime = moment(lastTimeStamp);
      let diffrenceTime = moment().diff(lastTime); // Time left from current time to last updated
      console.log('difference time ', diffrenceTime, 'last time stamp', lastTimeStamp);

      if (diffrenceTime > TIME_TO_TRIGGER) {
        //console.log('difference time is more', diffrenceTime);
        diffrenceTime = TIME_TO_TRIGGER;
      }
      addPointApi(TIME_TO_TRIGGER, diffrenceTime);
    }
    return () => {
      clearTimeout(addPointApiTimer);
    };
  }, [lastTimeStamp, data]);

  const addPointApi = (triggertime, diffrenceTime) => {
    clearTimeout(loadingTimer);
    clearTimeout(addPointApiTimer);
    let timeOutTime = triggertime - diffrenceTime + EXTRATIME_TO_TRIGGER;
    addPointApiTimer = setTimeout(function () {
      graphAddPointApiCall();
    }, timeOutTime);
  };

  useEffect(() => {
    setCanPlaySound(true);
  }, []);

  useEffect(() => {
    setSlideshowPayload({
      auth: true,
      url: `v0/shop-floor-view/slide-shows/${slideShowId}/show/`
    });
  }, []);

  const graphAddPointApiCall = () => {
    setSlideshowPayload({
      auth: true,
      url: `v0/shop-floor-view/slide-shows/${slideShowId}/show/`,
      params: {
        last_reading_time: lastTimeStamp
      }
    });
  };

  useEffect(() => {
    if (!data) return;

    // API level error
    if (apiError) {
      setError('Failed to load slideshow data. Please try again.');
      return;
    }

    const responseData = data?.data?.data;

    // Invalid response or empty slideshow
    if (!responseData || !responseData.tagged_slides?.length) {
      setError('No slides available for this slideshow.');
      return;
    }

    const filteredData = {
      ...responseData,
      tagged_slides: responseData.tagged_slides.filter(
        (slide) => slide.tagged_equipment?.length > 0
      )
    };

    if (!filteredData.tagged_slides.length) {
      setError('Slides exist but no equipment is tagged.');
      return;
    }

    setTasks(filteredData);
    setCurrentSlide(filteredData.tagged_slides[0]);
    setLastTimeStamp(data?.data?.last_reading_time);
  }, [data, apiError]);

  useEffect(() => {
    setCurrentSlide(tasks?.tagged_slides?.[currentSlideIndex]);
  }, [currentSlideIndex]);

  // Auto-refresh API every 2 minutes
  useEffect(() => {
    if (!slideShowId) return;

    const interval = setInterval(() => {
      setSlideshowPayload({
        auth: true,
        url: `v0/shop-floor-view/slide-shows/${slideShowId}/show/`,
        params: { last_reading_time: lastTimeStamp }
      });
    }, 120000); // 2 minutes

    return () => clearInterval(interval);
  }, [id, lastTimeStamp]);

  // eslint-disable-next-line no-unused-vars
  function formatTime(timestamp) {
    const date = new Date(timestamp);
    const options = { hour: '2-digit', minute: '2-digit' };
    return timestamp == null ? '' : date.toLocaleTimeString([], options); // Format to only show time
  }

  // Helper: chunk array only when needed
  const chunkArray = (arr, size) => {
    if (!arr) return [];
    const result = [];
    for (let i = 0; i < arr?.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const getStatusStyle = (machine_status) => {
    const baseStyle = {
      border: '5px solid',
      borderRadius: '8px'
    };

    switch (machine_status?.toLowerCase()) {
      case 'standby':
        return {
          ...baseStyle,
          backgroundColor: 'rgba(255, 123, 123, 0.3)', // #FF7B7B with 30% opacity
          borderColor: '#FF7B7B',
          color: 'inherit'
        };

      case 'sleep':
        return {
          ...baseStyle,
          backgroundColor: 'rgba(245, 221, 135, 0.3)', // #F5DD87 with 30% opacity
          borderColor: '#F5DD87',
          color: 'inherit'
        };

      case 'production':
        return {
          ...baseStyle,
          backgroundColor: 'rgba(106, 178, 160, 0.3)', // #6AB2A0 with 30% opacity
          borderColor: '#6AB2A0',
          color: 'inherit'
        };

      case 'off':
        return {
          ...baseStyle,

          borderColor: '#cccacaff',
          color: 'rgba(155, 155, 153, 0.5)' // 50% opacity for text
        };

      default:
        return {
          ...baseStyle,

          borderColor: '#cccacaff',
          textColor: 'rgba(155, 155, 153, 0.5)'
        };
    }
  };

  const getFontSize = (index, height) => {
    const numericHeight = parseFloat(height);

    if (index === 0) {
      console.log('40', numericHeight);
      return numericHeight < 40 ? 'clamp(28px, 2vw, 36px)' : 'clamp(56px, 5vw, 72px)';
    } else {
      console.log('30', numericHeight);
      return numericHeight < 40 ? 'clamp(22px, 2vw, 26px)' : 'clamp(40px, 3.5vw, 56px)';
    }
  };

  //debug
  useEffect(() => {
    console.log('Main Slide Index:', currentSlideIndex, 'Sub Slide Index:', subSlideIndex);
    console.log('Current slide equipment count:', tasks.tagged_slides?.[currentSlideIndex]?.tagged_equipment?.length || 0);
  }, [currentSlideIndex, subSlideIndex]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <h4 className="text-danger mb-3">⚠️ Error</h4>
          <p>{error}</p>

          <div className="d-flex justify-content-center gap-2 mt-3">
            <button
              className="btn btn-primary"
              onClick={() => window.location.reload()}>
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`slideShowContainer ${isFullWindowed ? 'expand-full-window' : ''}`}>
      {
        <div
          className="element p-3"
          id="elements"
          style={{
            display: isElementVisible ? 'block' : 'block',
            backgroundColor: isElementVisible ? 'white' : 'white'
          }}>
          <div className="d-flex justify-content-end my-2">
            {isFullscreen && (
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => {
                  setIsElementVisible(false);
                  handleExitFullscreen();
                }}></button>
            )}
          </div>
          <div style={{ textAlign: 'center' }}>
            <h1 className="mb-2">{tasks?.tagged_slides?.[currentSlideIndex]?.name}</h1>
            {tasks?.tagged_slides?.map((task, index) => {
              if (index !== currentSlideIndex) return null;

              const equipmentList = task?.tagged_equipment || [];
              if (!equipmentList.length) return <div key={index}>No Data</div>;

              // Only chunk if more than 12 cards, otherwise use single chunk
              let equipmentChunks = [];
              if (equipmentList.length > 12) {
                equipmentChunks = chunkArray(equipmentList, 12);
              } else {
                equipmentChunks = [equipmentList]; // Single chunk for 12 or fewer cards
              }

              const activeChunk = equipmentChunks[subSlideIndex] || [];

              if (!activeChunk.length) return <div key={index}>No Data</div>;

              return (
                <div
                  key={index}
                  className="dynamic-grid"
                  style={{
                    display: 'grid',
                    gap: '1rem',
                    gridTemplateColumns:
                      activeChunk.length === 1
                        ? '1fr'
                        : activeChunk.length <= 3
                        ? 'repeat(2, 1fr)'
                        : 'repeat(3, 1fr)',
                    justifyItems: 'stretch',
                    alignItems: 'stretch'
                  }}>
                  {activeChunk.map((item, i, arr) => {
                    const count = arr.length;
                    let height = 'auto';
                    if (count <= 2) height = '80vh';
                    else if (count <= 6) height = '40vh';
                    else if (count <= 9) height = '27vh';
                    else height = '20vh';

                    return (
                      <Card
                        key={i}
                        className={`card ${item.is_schedule_criteria_met ? 'blinking-border' : ''}`}
                        style={{
                          width: '100%',
                          height,
                          boxShadow: '0px 4px 8px 0px rgba(0,0,0,0.1)',
                          transition: 'box-shadow 0.3s ease',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          position: 'relative',
                          ...getStatusStyle(item?.machine_status),
                          borderWidth: item.is_schedule_criteria_met ? '10px' : '5px',
                          borderStyle: 'solid'
                        }}>
                        {/* Card Body with top and bottom spacing */}
                        <Card.Body
                          className="d-flex flex-column justify-content-between p-3 text-center"
                          style={{ minHeight: '100%' }}>
                          {/* Equipment Name - Top Section with margin */}
                          <div className="mt-3">
                            <Card.Title
                              className="w-100"
                              style={{
                                lineHeight: '1.1',
                                overflow: 'hidden',
                                maxHeight: '100%'
                              }}>
                              {(() => {
                                const name = item?.equipment_name || '';
                                const words = name.split(' ');

                                // Smart line breaking logic
                                const breakIntoLines = (words) => {
                                  const lines = [];

                                  if (words.length === 0) return [''];

                                  // For 1-2 words: all in first line
                                  if (words.length <= 2) {
                                    return [words.join(' ')];
                                  }

                                  // For 3 words: try to balance based on character length
                                  if (words.length === 3) {
                                    const firstWordLen = words[0].length;
                                    const secondWordLen = words[1].length;
                                    const thirdWordLen = words[2].length;

                                    // If first word is long, put it alone on first line
                                    if (firstWordLen > 12) {
                                      return [[words[0]], [words[1], words[2]].join(' ')];
                                    }
                                    // Otherwise put first two words on first line
                                    return [[words[0], words[1]].join(' '), words[2]];
                                  }

                                  // For 4+ words: smart distribution
                                  let currentLine = [];
                                  const totalChars = words.join('').length;
                                  const avgCharsPerLine = totalChars / 3;

                                  for (let i = 0; i < words.length; i++) {
                                    currentLine.push(words[i]);
                                    const currentLineChars = currentLine.join('').length;

                                    // Break to next line if:
                                    // 1. We have at least 2 words AND
                                    // 2. Either:
                                    //    - We're at the last word
                                    //    - Current line is getting long
                                    //    - Next word would make it too long
                                    if (
                                      currentLine.length >= 2 &&
                                      (i === words.length - 1 ||
                                        currentLineChars >= avgCharsPerLine ||
                                        (words[i + 1] &&
                                          currentLineChars + words[i + 1].length >
                                            avgCharsPerLine * 1.5))
                                    ) {
                                      lines.push(currentLine.join(' '));
                                      currentLine = [];
                                    }
                                  }

                                  // Add any remaining words
                                  if (currentLine.length > 0) {
                                    lines.push(currentLine.join(' '));
                                  }

                                  // Ensure we have exactly 3 lines
                                  while (lines.length < 3) {
                                    lines.push('');
                                  }
                                  if (lines.length > 3) {
                                    // If we have more than 3 lines, merge last two lines
                                    const mergedLastLine = lines.slice(2).join(' ');
                                    return lines.slice(0, 2).concat(mergedLastLine);
                                  }

                                  return lines;
                                };

                                const lines = breakIntoLines(words);

                                return lines.slice(0, 3).map((line, index) => {
                                  if (!line) return null;

                                  // Check if we need to truncate (only for last line)
                                  const shouldTruncate = index === 2 && line.length > 25;
                                  const displayText = shouldTruncate
                                    ? line.substring(0, 22) + '...'
                                    : line;

                                  return (
                                    <div
                                      key={index}
                                      className={shouldTruncate ? 'text-truncate' : ''}
                                      style={{
                                        fontSize: getFontSize(index, height),
                                        lineHeight: '1.1',
                                        marginBottom: '2px'
                                      }}>
                                      {displayText}
                                    </div>
                                  );
                                });
                              })()}
                            </Card.Title>
                          </div>

                          {/* Status and kW - Bottom Section with margin */}
                          <div className="mb-3">
                            <Card.Text
                              style={{
                                fontSize: height >= '40vh' ? '40px' : '20px',
                                lineHeight: '1.1',
                                marginBottom: '2px'
                              }}>
                              <div>{item?.kw_value?.toFixed(2) || 0} kW</div>
                              <div>{item?.machine_status}</div>
                            </Card.Text>
                          </div>
                        </Card.Body>

                        {/* Alert Sign - Bottom Right */}
                        {item.is_schedule_criteria_met && (
                          <GoAlert
                            className="hazard-icon"
                            style={{
                              position: 'absolute',
                              bottom: '12px',
                              right: '12px',
                              color: 'rgba(255, 0, 0, 0.4)',
                              fontSize:
                                height < '40vh'
                                  ? 'clamp(22px, 2vw, 26px)'
                                  : 'clamp(56px, 5vw, 72px)'
                            }}
                          />
                        )}
                      </Card>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      }
    </div>
  );
};